import React from 'react'
import './ProductosLoading.css'
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, Autoplay } from 'swiper';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

export default function ProductosLoading() {
    return (
        <div className='loadingContain'>

            <Swiper
                modules={[Navigation, Pagination, Autoplay]}
                effect={'coverflow'}
                grabCursor={true}
                slidesPerView={'auto'}
                className='cardsLoading'
            >

                <SwiperSlide className='cardLoading' >

                </SwiperSlide>
                <SwiperSlide className='cardLoading' >

                </SwiperSlide>

                <SwiperSlide className='cardLoading' >

                </SwiperSlide>
                <SwiperSlide className='cardLoading' >

                </SwiperSlide>
                <SwiperSlide className='cardLoading' >

                </SwiperSlide>

            </Swiper>


            <Swiper
                effect={'coverflow'}
                grabCursor={true}
                slidesPerView={'auto'}
                className='cardsLoading2'
            >

                <SwiperSlide className='cardLoading2' >

                </SwiperSlide>
                <SwiperSlide className='cardLoading2' >

                </SwiperSlide>

                <SwiperSlide className='cardLoading2' >

                </SwiperSlide>
                <SwiperSlide className='cardLoading2' >

                </SwiperSlide>
                <SwiperSlide className='cardLoading2' >

                </SwiperSlide>

            </Swiper>
        </div>
    )
}
